import { List, Typography } from 'antd';

const { Text } = Typography;

const NonReturnedCompleteCollection = () => {

  const data = [
    'Kg’lı siparişlerde toplanan kg farkları bu oranı etkilemez.',
    'Eksik toplanan poşetler bu oranı etkilemez.',
    'Aşağıdaki durumlarda bu KPI için ilgili sipariş başarısız sayılır:',
    'DESCRIPTION',
    'Bir sipariş teslim edilene kadar yukarıdaki koşullardan birine uğramış ve başarısız olduğu kesinleşmiş ise teslimatı beklemeden doğrudan orana yansır.',
    'Sipariş ileri slotlu olsa da teslim edildikten sonra ilgili orana yansır.',
    'Siparişin tümü iptal edilmiş ise buraya yansımaz.',
    'Sipariş teslim edilirken başarılı olmasına rağmen sonraki günlerde marketten iade girilir ise ilgili aya ait oranı olumsuz olarak etkiler.',
    'Aylık performansta ilgili ayın 1’inden itibaren o ana kadar olan siparişler üzerinden oran gösterilir.',
    'İlgili oran merkez tarafından belirlenen hedef değerinden daha yüksekse yeşil, düşükse kırmızı renk ile gösterilir.'
  ];

  const data2 = [
    'Toplama aşamasında en az 1 ürün iptal edilmiş ise',
    'Dağıtıcı teslimat aşamasında en az 1 ürünü kapıda iade almış ise',
    'Müşteri teslimattan sonra en az 1 ürünü marketten iade etmiş ise',
  ];

  return (<List
    className="demo-loadmore-list"
    itemLayout="horizontal"
    dataSource={data}
  >
    <List.Item.Meta
      style={{ marginBottom: 10 }}
      title={
        <Text strong style={{ fontSize: 16 }}>
          İlgili dağıtım tarihine ait siparişlerin ne kadarında tüm ürünlerin toplanıp herhangi bir
          şekilde iade alınmadan teslim edildiğini gösteren orandır.
        </Text>
      }
    />
    <ul>
      {data.map((item, index) => (
        item === 'DESCRIPTION' ? data2.map((item2, index) => (<ul><li>{item2}</li></ul>) ) :
          <li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>
      ))}
    </ul>
  </List>);
};

export default NonReturnedCompleteCollection;
